module.exports = __webpack_public_path__ + "static/media/share-link-desktop.b7c45b9d.svg";